<template>
  <div>
    <van-form ref="addForm" validate-trigger="onSubmit" class="formSty">
      <van-collapse v-model="activeNames">
        <van-collapse-item title="基本信息" name="1">
          <van-field v-model="form.custName" label="客户全称" :rules="[{ required: true }]" placeholder="请填写客户名称" required />
          <van-field readonly clickable v-model="address" label="所在区域" @click="showArea" :rules="[{ required: true }]" placeholder="请选择所在区域" required />
          <van-field v-model="form.custAddress" label="详细地址" :rules="[{ required: true }]" placeholder="请填写详细地址" required />
          <!-- <van-field v-model="form.mainProducts" label="合作产品" placeholder="请输入投放的具体商品或开发的具体系统" :rules="[{ required: true }]" required /> -->

          <van-cell title="客户来源" required class="label">
            <template #label>
              <div v-for="(item,index) in options.custSourceOptions" :key="index">
                <span class="label_title">{{item.custSourceName}}:</span>
                <van-tag size="large" type='primary' v-for="(val,i) in item.children" :key="i" @click="clickTag('custSource',val.custSourceId)" color="#F4F5F7"
                  text-color="#606060" :class="form.custSource == val.custSourceId?'tag-click':'tag-before'">{{val.custSourceName}}</van-tag>
              </div>
            </template>
          </van-cell>
          <van-cell title="客户等级" required>
            <template #label>
              <van-tag size="large" type='primary' v-for="(item,index) in options.custLevelOptions" :key="index" @click="clickTag('custLevel',item.dictValue)" color="#F4F5F7"
                text-color="#606060" :class="form.custLevel == item.dictValue?'tag-click':'tag-before'">{{item.dictLabel}}</van-tag>
            </template>
          </van-cell>
          <van-cell title="单位性质" required>
            <template #label>
              <van-tag size="large" type='primary' v-for="(item,index) in options.unitNatureOptions" :key="index" @click="clickTag('unitNature',item.dictValue)" color="#F4F5F7"
                text-color="#606060" :class="form.unitNature == item.dictValue?'tag-click':'tag-before'">{{item.dictLabel}}</van-tag>
            </template>
          </van-cell>
          <van-cell title="所属行业" required class="label_industry">
            <template #right-icon>
              <van-button size="mini" type='primary' @click="chooseIndustry">选择</van-button>
            </template>
            <template>
              <van-tag size="large" type='primary' text-color="#606060" :class="form.industryName?'tag-click':'tag-before'">{{form.industryName || '请选择'}}</van-tag>
            </template>
          </van-cell>

          <!-- <van-field readonly clickable v-model="form.custSourceName" @click="showPicker('custSource')" label="客户来源" placeholder="请选择客户来源" required :rules="[{ required: true }]" /> -->
          <!-- <van-field readonly clickable v-model="form.custLevelName" @click="showPicker('custLevel')" label="客户等级" placeholder="请选择客户等级" required :rules="[{ required: true }]" /> -->
          <!-- <van-field readonly clickable v-model="form.unitNatureName" @click="showPicker('unitNature')" label="单位性质" placeholder="请选择单位性质" required :rules="[{ required: true }]" /> -->
          <!-- <van-field readonly clickable v-model="form.industryName" label="所属行业" @click="showPicker('industry')" placeholder="请选择所属行业" required :rules="[{ required: true }]" /> -->

          <!-- <van-field v-model="form.custAbbName" label="客户简称" placeholder="请填写客户简称"/> -->
          <!-- <van-field v-model="form.custCode" disabled label="客户编码" placeholder="由系统后端自动生成"/> -->
          <!-- <van-field v-model="form.enterpriseMailbox" label="企业邮箱" placeholder="请填写企业邮箱"/>
          <van-field v-model="form.website" label="企业网站" placeholder="请填写企业网站" /> -->
          <!-- <van-field v-model="form.lng" label="经度" placeholder="请填写经度"/>
          <van-field v-model="form.lat" label="纬度" placeholder="请填写纬度" /> -->
          <!-- <van-field readonly clickable v-model="address" label="地区" @click="showArea" :rules="[{ required: true }]" placeholder="请选择地区" required />
          <van-field v-model="form.custAddress" label="详细地址" :rules="[{ required: true }]" placeholder="请填写详细地址" required />
          <van-field name="uploader" v-if="form.custLogo" label="企业形象图片">
            <template #input>
              <van-uploader v-model="form.custLogo" :after-read="uploadContractPictureFiles" :before-read="beforeRead" :deletable="true" :before-delete="handleContractRemove" :max-count="9" :multiple="true" :max-size="52428800" upload-text="合同相片" />
            </template>
          </van-field>
          <van-field name="uploader" v-if="form.businessLicenseImg" label="营业执照">
            <template #input>
              <van-uploader v-model="form.businessLicenseImg" :after-read="uploadContractPictureFiles" :before-read="beforeRead" :deletable="true" :before-delete="handleContractRemove" :max-count="9" :multiple="true" :max-size="52428800" upload-text="合同相片" />
            </template>
          </van-field> -->
        </van-collapse-item>
        <van-collapse-item :title="'联系人'+(index+1)" :name="index" v-for="(pel,index) in form.contactList" :key="index">
          <van-field v-model="pel.contactName" label="姓名" maxlength="10" :rules="[{ required: true }]" name="contactName" placeholder="请输入姓名" required />
          <van-field readonly clickable v-model="pel.sexName" @click="showPicker('sex',index)" label="性别" placeholder="请选择性别" required :rules="[{ required: true }]" />
          <van-field v-model="pel.jobs" label="职务" maxlength="20" :rules="[{ required: true }]" name="contactName" placeholder="请输入职务" required/>
          <van-field v-model="pel.mobile" label="手机" maxlength="11" type="tel" placeholder="手机或微信必须填写一个"/>
          <van-field v-model="pel.weixinSn" label="微信号" name="contactName" placeholder="请输入微信号"/>
          <!-- <van-collapse v-model="activeLink">
            <van-collapse-item title="添加更多联系人信息" size='mini' name="1">
              <van-field v-model="pel.deptName" label="部门" name="deptName" placeholder="请输入部门" />
              <van-field readonly clickable v-model="pel.callNameName" @click="showPicker('callName',index)" label="称呼" placeholder="请选择" />
              <van-field v-model="pel.nickName" label="用户昵称" maxlength="20" name="contactName" placeholder="请输入用户昵称" />
              <van-field readonly clickable v-model="pel.ideTypeName" @click="showPicker('ideType',index)" label="证件类型" placeholder="请选择" />
              <van-field v-model="pel.ideSn" label="证件号" name="contactName" placeholder="请输入证件号" />
              <van-field v-model="pel.jobTitle" label="工作头衔" name="contactName" placeholder="请输入工作头衔" /> -->
              <!-- <van-field v-model="pel.jobs" label="职务" name="contactName" placeholder="请输入职务" /> -->
              <!-- <van-field v-model="pel.weixinSn" label="微信号" name="contactName" placeholder="请输入微信号"/> -->
              <!-- <van-field v-model="pel.email" label="邮箱" name="contactName" placeholder="请输入邮箱" />
              <van-field v-model="pel.qq" label="QQ" name="contactName" placeholder="请输入QQ" />
              <van-field v-model="pel.age" label="年龄" name="contactName" placeholder="请输入年龄" />
              <van-field v-model="pel.birthday" readonly clickable name="calendar" label="生日" placeholder="点击选择日期" @click="handelBirthday(index)" />
              <van-field readonly clickable v-model="pel.intimacyName" @click="showPicker('intimacy',index)" label="亲密度" placeholder="请选择" />
              <van-field v-model="pel.hobby" label="爱好" placeholder="请输入爱好"/>
              <van-field v-model="pel.remark" label="备注" placeholder="请输入备注" />
            </van-collapse-item>
          </van-collapse> -->
          <div class="link">
            <van-button class="linkaddBtn" round block type="primary" native-type="button" size="small" @click="addPerson">追加联系人</van-button>
            <van-button class="linkaddBtn" v-if="index!=0" round block type="warning" native-type="button" size="small" @click="delPerson(index)">删除</van-button>
          </div>
        </van-collapse-item>
        <!-- <van-collapse-item title="分类信息" name="2">
          <van-field readonly clickable v-model="form.custTypeName" @click="showPicker('custType')" label="客户类型" placeholder="请选择" /> -->
          <!-- <van-field readonly clickable v-model="form.custStatusName" @click="showPicker('custStatus')" label="客户状态" placeholder="请选择" :rules="[{ required: true }]" required  /> -->
          <!-- <van-field readonly clickable v-model="form.custSourceName" @click="showPicker('custSource')" label="客户来源" placeholder="请选择" /> -->
          <!-- <van-field readonly clickable v-model="form.acquireWayName" @click="showPicker('acquireWay')" label="获得途径" placeholder="请选择" />
          <van-field readonly clickable v-model="form.scaleName" @click="showPicker('scale')" label="企业规模" placeholder="请选择" /> -->
          <!-- <van-field readonly clickable v-model="form.unitNatureName" @click="showPicker('unitNature')" label="单位性质" placeholder="请选择" /> -->
          <!-- <van-field v-model="form.industryName" label="行业名称" placeholder="请填写行业名称"/> -->
          <!-- <van-field readonly clickable v-model="form.industryName" label="行业" @click="showPicker('industry')" placeholder="请选择行业" /> -->
          <!-- <van-field readonly clickable v-model="form.custLevelName" @click="showPicker('custLevel')" label="客户等级" placeholder="请选择"  /> -->
        <!-- </van-collapse-item> -->
        <!-- <van-collapse-item title="授信" name="3">
          <van-field v-model="form.creditLimit" label="信用额度"  placeholder="请填写信用额度" />
          <van-field v-model="form.creditPeriod" label="信用期间"  placeholder="请填写信用期间" />
          <van-field v-model="form.bankAccount" label="收款账户"  placeholder="请填写收款账户" />
          <van-field v-model="form.bankDeposit" label="开户行"  placeholder="请填写开户行" />
          <van-field v-model="form.account" label="账户名"  placeholder="请填写账户名" />
          <van-field v-model="form.custTaxNum" label="企业纳税识别号"  placeholder="请填写企业纳税识别号" />
        </van-collapse-item> -->
        <!-- <van-collapse-item title="标签信息" name="4"> -->
          <!-- <div>
            <div>已选标签:</div>
            <div style="display: flex;flex-wrap: wrap;">
              <div style="margin: 0.1rem;">
              <van-tag v-if="true" size="medium" type="primary">標簽</van-tag>
              </div>
            </div>
          </div> -->
          <!-- <div v-for="(item, index) in tagList" :key="index">
            <div>{{item.qwGroupName}}:</div>
            <div style="display: flex;flex-wrap: wrap;">
              <div style="margin: 0.1rem;" v-for="(v, i) in item.sysTagList" :key="i">
              <van-tag @click="checkTag(index,i)" size="medium" plain type='primary' :text-color="!v.isCheck ? '#c1c1c1' : ''">{{ v.qwTagName }}</van-tag>
            </div>
            </div>
          </div>
        </van-collapse-item> -->
      </van-collapse>
      <van-button class="addBtn" round block type="info" native-type="submit" size="small" v-preventReClick @click="handleAdd">保存</van-button>
    </van-form>
    <!-- 日期选择器 -->
    <van-calendar v-model="showBirthday" :min-date="minDate" type="single" @confirm="birthdayCalendarConfirm" />

    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" @change="pickerChange" />
    </van-popup>
    <van-dialog v-model="areashow" width='98%' title="标题" :showConfirmButton='false' @close='areashow=false'>
      <van-area title="选择地区" @confirm = 'areaConfirm'  @cancel= 'areaCancel' :area-list="areaList" value="430104" />
    </van-dialog>
    <van-dialog v-model="industryShow" title="选择所属行业" show-cancel-button>
      <van-tag size="large" type='primary' v-for="(item,index) in options.industryOptions" :key="index" @click="clickTag('industryCode',item.dictValue,item.dictLabel)" color="#F4F5F7"
        text-color="#606060" :class="form.industryCode == item.dictValue?'tag-click':'tag-before'">{{item.dictLabel}}</van-tag>
    </van-dialog>
  </div>
</template>

<script>
import { listCust, getCust, addCust, updateCust, getDistrict, tagList, getSourceTree } from '@/api/scrm/mycust'
import { getDicts } from '@/api/system/dict/data'
import { getdistrict } from '@/api/system/district.js'
import { areaList } from '@vant/area-data'
import { Toast, Tag } from 'vant'
import { handleTree } from '@/utils/util'
import { getTwoLevelIndustryList } from '@/api/system/qqAdIndustry'
export default {
  name: 'custModifyInfos',
  components: {
    [Toast.name]: Toast,
    [Tag.name]: Tag
  },
  data() {
    return {
      activeNames: ['1', 0],
      industryShow: false,
      activeLink: [],
      isEmpty: false,
      areashow: false,
      isAdd: false,
      picker: {
        visible: false,
        visibleIndustry: false,
        title: '',
        columns: [],
        formKey: ''
      },
      address: '',
      minDate: new Date(2010, 0, 1),
      loading: false,
      finished: false,
      list: [],
      show: false,
      type: 'add',
      showFilterPop: false,
      showBirthday: false,
      searchValue: '',
      custList: [],
      options: {
        // 客户类型字典
        custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
        // 行业类型
        businessTypeOptions: this.$store.state.dictOptions.businessTypeTree || [],
        // 客户来源字典
        // custSourceOptions: this.$store.state.dictOptions.custSource || [],
        custSourceOptions: [],
        // 客户状态
        custStatusOptions: this.$store.state.dictOptions.custStatus || [],
        // 性别状态字典
        sexOptions: this.$store.state.dictOptions.sex || [],
        // 行业
        industryOptions: []
      },
      form: {
        custId: null,
        custName: this.$route.query.custName,
        custType: this.$route.query.custType,
        custTypeName: this.$route.query.custTypeName,
        province: '',
        city: '',
        area: '',
        lng: '',
        lat: '',
        latLong: '',
        custAddress: '',
        contactList: [{
          contactName: '',
          callName: '',
          jobs: '',
          mobile: ''
        }]
      },
      queryParams: {},
      areaList: areaList,
      index: null,
      tagShow: false,
      tagList: [],
      checkTagList: [],
      disablecustCode: false
    }
  },
  async created() {
    await this.getOptions()
    this.getTagList()
    if (this.$route.query.custId) {
      this.getCustomer(this.$route.query.custId)
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      // 修改主体框架标题
      document.title = 'SCRM-修改客户'
    },
    getOptions() {
      getSourceTree().then(res => {
        this.options.custSourceOptions = handleTree(res.rows, 'custSourceId')
        console.log(this.options.custSourceOptions)
      })
      getTwoLevelIndustryList().then((res) => {
        this.options.industryOptions = handleTree(res.data, 'systemIndustryId')
        this.options.industryOptions.map(item => {
          item.dictLabel = item.industryName
          item.dictValue = item.systemIndustryId
        })
      })
      getDicts('crm_mycust_type').then(res => {
        this.options.custTypeOptions = res.data
      })
      getDicts('crm_scale').then(res => {
        this.options.scaleOptions = res.data
      })
      getDicts('crm_cust_status').then(res => {
        this.options.custStatusOptions = res.data
      })
      getDicts('crm_acquire_way').then(res => {
        this.options.acquireWayOptions = res.data
      })
      getDicts('crm_unit_nature').then(res => {
        this.options.unitNatureOptions = res.data
      })
      getDicts('crm_cust_level').then(res => {
        this.options.custLevelOptions = res.data
      })
      getDicts('crm_call_name').then(res => {
        this.options.callNameOptions = res.data
      })
      // getDicts('crm_cust_source').then(res => {
      //   this.options.custSourceOptions = res.data
      // })
      // 证件类型
      getDicts('crm_ide_type').then(res => {
        this.options.ideTypeOptions = res.data
      })
      // 亲密度
      getDicts('crm_intimacy').then(res => {
        this.options.intimacyOptions = res.data
      })
      // 性别
      getDicts('sys_user_sex').then(res => {
        this.options.sexOptions = res.data
      })
    },
    async getCustomer(id) {
      const res = await getCust(id)
      if (res.code === 200) {
        this.form = res.data
        if (this.form.custAddress) { this.form.custAddress = this.form.custAddress.replace(this.form.areaName, '') }
        this.address = this.form.areaName
        this.setName('custType')
        this.setName('custStatus')
        this.setName('custSource')
        this.setName('acquireWay')
        this.setName('scale')
        this.setName('unitNature')
        this.setName('custLevel')
        if (this.form.contactList && this.form.contactList.length > 0) {
          for (let i = 0; i < this.form.contactList.length; i++) {
            const element = this.form.contactList[i]
            this.setLinkName('callName', element)
            this.setLinkName('ideType', element)
            this.setLinkName('sex', element)
            this.setLinkName('intimacy', element)
          }
        } else {
          this.form.contactList = []
          this.form.contactList.push({
            contactName: '',
            callName: '',
            jobs: '',
            mobile: ''
          })
        }
        this.disablecustCode = true
      }
      setTimeout(() => {
        this.tagList.forEach(item => {
          item.sysTagList.forEach(v => {
            res.data.custTagsList.forEach(j => {
              if (v.qwTagName === j) {
                v.isCheck = true
                this.checkTagList.push(v)
              }
            })
          })
        })
      }, 0)
    },
    setName(type) {
      const optionItem = type + 'Options'
      const obj = this.options[optionItem].find((item, index) => {
        return item.dictValue == this.form[type]
      })
      if (obj != null) {
        const name = type + 'Name'
        this.form[name] = obj.dictLabel
      }
    },
    setLinkName(type, element) {
      const optionItem = type + 'Options'
      const obj = this.options[optionItem].find((item, index) => {
        return item.dictValue == element[type]
      })
      if (obj != null) {
        const name = type + 'Name'
        element[name] = obj.dictLabel
      }
    },
    toCustBlueDetails(item) {
      this.$router.push(`/scrm/custclue/detail/${item.custId}`)
    },
    formatHandel(type, value) {
      const optionItem = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[optionItem], value)
      } else {
        return ''
      }
    },
    async showPicker(type, index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      if (type == 'custSource') {
        this.picker.formKey = type
        const optionItem = type + 'Options'
        getSourceTree().then(res => {
          this.options.custSourceOptions = handleTree(res.rows, 'custSourceId')
          console.log(this.options.custSourceOptions)
          this.picker.columns = this.options[optionItem].map((ele) => this.industryNormalizer(ele))
        })
      }
      if (type === 'industry') {
        if (this.options.industryOptions.length == 0) {
          await getTwoLevelIndustryList().then((res) => {
            this.options.industryOptions = handleTree(res.data, 'systemIndustryId')
            this.options.industryOptions.map(item => {
              item.dictLabel = item.industryName
              item.dictValue = item.systemIndustryId
            })
          })
        }
        console.log(this.options.industryOptions)
        // this.options.industryOptions.map(item => {
        //   item.dictLabel = item.industryName
        //   item.dictValue = item.systemIndustryId
        // })
        this.picker.formKey = type
        const optionItem = type + 'Options'
        // this.picker.columns = this.options[optionItem].map((ele) => this.industryNormalizer(ele))
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
        //   this.picker.columns = this.businessTypeOptions.map(ele => this.businessNormalizer(ele))
        // this.picker.columns = this.options[optionItem].map(ele => this.industryNormalizer(ele))
        this.picker.visible = true
      } else {
        this.picker.formKey = type
        const optionItem = type + 'Options'
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
        this.picker.visible = true
      }
    },
    pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      console.log('key:' + key)
      const name = this.picker.formKey + 'Name'
      if (this.picker.formKey == 'custSource') {
        if (value.length == 2) {
          if (value[1].length > 0) {
            const obj = this.options[optionItem].find(
              (item) => item.custSourceName === value[0]
            )
            if (obj != null) {
              this.form.custSource = obj.children.find(
                (item) => item.custSourceName === value[1]
              ).custSourceId
            }
            this.form.custSourceName = value[0] + '/' + value[1]
          }
        } else {
          this.form.custSourceName = value[0]
          const obj = this.options[optionItem].find(
            (item) => item.custSourceName === value[0]
          )
          if (obj != null) {
            this.form.custSource = obj.custSourceId
          }
        }
      } else if (this.picker.formKey == 'industry') {
        this.form.industryName = value
        this.form.industryCode = this.options.industryOptions[key].dictValue
      } else {
        if (this.index || this.index == 0) {
          this.form.contactList[this.index][this.picker.formKey] = this.options[optionItem][key].dictValue
          this.form.contactList[this.index][name] = this.options[optionItem][key].dictLabel
        } else {
          this.form[this.picker.formKey] = this.options[optionItem][key].dictValue
          this.form[name] = this.options[optionItem][key].dictLabel
        }
      }

      this.picker.visible = false
    },
    chooseIndustry() {
      this.industryShow = true
    },
    clickTag(name, val, val2) {
      this.form[name] = val
      if (val2) {
        this.form.industryName = val2
      }
    },
    areaConfirm(values) {
      this.form.province = values[0].code
      this.form.city = values[1].code
      this.form.area = values[2].code
      this.address = values[0].name + values[1].name + values[2].name
      this.areashow = false
      getDistrict(values[2].code).then(res => {
        const data = res.data
        this.form.latLong = data.lat + ',' + data.lng
      })
    },
    areaCancel() {
      this.areashow = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    pickerChange() { },
    addCust() {
      this.show = true
    },
    addPerson() {
      const peo = {
      }
      this.form.contactList.push(peo)
      const res = this.activeNames.some(item => {
        return this.form.contactList.length - 1 === item
      })
      if (res === false) {
        this.activeNames.push(this.form.contactList.length - 1)
      }
    },
    delPerson(item) {
      this.form.contactList.splice(item, 1)
    },
    handelBirthday(index) {
      this.showBirthday = true
      this.index = index
    },
    async handleAdd() {
      await this.$refs.addForm.validate()
      if (this.address == this.form.custAddress || (this.form.custAddress).indexOf(this.address) != -1) {
        this.form.areaName = this.address
      } else {
        // this.form.custAddress = this.address + this.form.custAddress
        this.form.areaName = this.address
      }
      if (this.$route.query.custId) {
        if (!this.form.custSource) {
          Toast.fail('请选择客户来源')
          return
        }
        if (!this.form.custLevel) {
          Toast.fail('请选择客户等级')
          return
        }
        if (!this.form.unitNature) {
          Toast.fail('请选择单位性质')
          return
        }
        if (!this.form.industryCode) {
          Toast.fail('请选择所属行业')
          return
        }
        const custTagsList = []
        this.checkTagList.forEach(item => {
          custTagsList.push(item.qwTagName)
        })
        this.form.custTagsList = custTagsList
        this.form.custTags = custTagsList.join(',')
        updateCust(this.form).then((response) => {
          Toast.success('修改客户成功!')
          setTimeout(() => {
            this.$router.go(-1)
          }, 500)
        })
      } else {
        const custTagsList = []
        this.checkTagList.forEach(item => {
          custTagsList.push(item.qwTagName)
        })
        this.form.custTagsList = custTagsList
        this.form.custTags = custTagsList.join(',')
        addCust(this.form).then((response) => {
          Toast.success('新增客户成功!')
          setTimeout(() => {
            this.$router.push('/scrm/myCust/list')
          }, 500)
        })
      }
    },
    async handleList() {
      this.loading = true
      await this.$refs.searchform.validate()
      const res = await listCust(this.form)
      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isAdd = true
        }
        // this.list = this.list.concat(...res.rows);
        this.list = res.rows
        this.finished = this.list.length >= res.total
        this.loading = false
      }
    },
    onLoad() {
      this.handleList()
    },
    /** 转换行业数据结构 */
    industryNormalizer(node) {
      const arr = []
      if (node.children && node.children.length) {
        for (const i in node.children) {
          const item = {
            id: node.children[i].custSourceId,
            text: node.children[i].custSourceName
          }
          arr.push(item)
        }
      }

      return {
        id: node.custSourceId,
        text: node.custSourceName,
        children: arr
      }
    },
    /** 转换地区数据结构 */
    areaNormalizer(node) {
      const arr = []
      if (node.children && node.children.length) {
        for (const i in node.children) {
          const item = {
            id: node.children[i].areaId,
            text: node.children[i].areaName
          }
          arr.push(item)
        }
      }

      return {
        id: node.areaId,
        text: node.areaName,
        children: arr
      }
    },
    /** 转换业务类型数据结构 */
    businessNormalizer(node) {
      const arr = []
      if (node.children && node.children.length) {
        for (const i in node.children) {
          const item = {
            id: node.children[i].businessTypeId,
            text: node.children[i].businessTypeName
          }
          arr.push(item)
        }
      }
      return {
        id: node.businessTypeId,
        text: node.businessTypeName,
        children: arr
      }
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    },
    birthdayCalendarConfirm(data) {
      this.form.contactList[this.index].birthday = this.formatDate(data)
      this.showBirthday = false
      this.minDate = data
    },
    showArea() {
      this.areashow = true
    },
    // 返回布尔值
    beforeRead(file) {
      if (
        file.type !== 'image/jpeg' &&
        file.type !== 'image/png' &&
        file.type !== 'image/jpg'
      ) {
        Toast('请上传 jpg 、jpeg、png 格式图片')
        return false
      }
      return true
    },
    handleContractRemove(file) {
      let picture = this.form.contractImg
      if (picture.indexOf(file.url) == 0) {
        if (picture.indexOf(',') == -1) {
          picture = null
        } else {
          picture = picture.replace(file.url + ',', '')
        }
      } else {
        picture = picture.replace(',' + file.url, '')
      }
      this.form.contractImg = picture
      this.pictureList = []
      if (this.form.contractImg != null && this.form.contractImg.length > 0) {
        const payCaptures = this.form.contractImg.split(',')
        payCaptures.forEach((element) => {
          this.pictureList.push({
            url: element
          })
        })
      }
    },
    // uploadContractPictureFiles(file) {
    //   const _file = file.file
    //   // 通过 FormData 对象上传文件
    //   var formData = new FormData()
    //   formData.append('file', _file)

    //   ucloudUpFileToContract(formData)
    //     .then((res) => {
    //       // console.log("_RequestUploads_", res);
    //       if (res.code === 200) {
    //         // this.form.contractImg = res.url;
    //         let picture = this.form.contractImg
    //         if (picture != null && picture.length > 0) {
    //           picture += ',' + res.url
    //         } else {
    //           picture = res.url
    //         }
    //         this.form.contractImg = picture
    //         const payCaptures = this.form.contractImg.split(',')
    //         this.pictureList = []
    //         payCaptures.forEach((element) => {
    //           this.pictureList.push({
    //             url: element
    //           })
    //         })
    //         Toast.success(res.msg)
    //       } else {
    //         Toast.fail('res.msg')
    //       }
    //     })
    //     .catch(function (error) {
    //       console.error(error)
    //     })
    // },
    // 省市区
    getdistrict(parent, type) {
      getdistrict({ parent: parent }).then((res) => {
        if (type == 1) {
          const province = res.rows
          for (let i = 0; i < province.length; i++) {
            const item = province[i]

            this.areaList.province_list[item.id] = item.fullname
          }
        } else if (type == 2) {
          const city = res.rows
          for (let i = 0; i < city.length; i++) {
            const item = city[i]
            this.areaList.city_list[item.id] = item.fullname
          }
        } else if (type == 3) {
          const county = res.rows
          for (let i = 0; i < county.length; i++) {
            const item = county[i]
            this.areaList.county_list[item.id] = item.fullname
          }
        }
      })
    },
    // 获取标签列
    async getTagList() {
      const parmes = {}
      const res = await tagList(parmes)
      this.tagList = res.rows
      this.tagList.forEach(item => {
        item.sysTagList.forEach(v => {
          v.isCheck = false
        })
      })
    },
    // 选中标签时
    checkTag(index, i) {
      this.tagList[index].sysTagList[i].isCheck = !this.tagList[index].sysTagList[i].isCheck
      const data = this.tagList[index].sysTagList[i]
      data.index = index
      data.childIndex = i
      if (this.tagList[index].sysTagList[i].isCheck === false) {
        this.checkTagList.forEach((v, l) => {
          if (v.index === index && v.childIndex === i) {
            this.checkTagList.splice(l, 1)
          }
        })
        this.$forceUpdate()
        return
      }
      this.checkTagList.push(data)
      this.$forceUpdate()
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.tag-click{
  border: 0.02667rem solid #1E90FF !important;
  color:#fff !important;
  background-color: #1E90FF !important;
}
.tag-before{
  border: 0.02667rem solid #999999 !important;
  background-color: #fff !important;
}
.label{
  .label_title{
    color: #333;
    font-size: 18px;
  }
}
/deep/ .van-tag{
  margin: 8px 0 8px 20px;
}
/deep/.van-collapse-item__content{
  padding: 10px;
}
.label_industry{
  .van-cell__value {
    min-width: 65%; //可根据自己需求设定值
    text-align: left;
  }
}
// .label /deep/.van-cell__title{
//   // flex: 0.3;
// }
</style>
